import type { LineValidation } from '@trackeat/shared';

export type DocumentMatchSource =
  | 'code'
  | 'alias_manual'
  | 'alias_ai'
  | 'alias_first_setup'
  | 'exact_name'
  | 'ilike'
  | null
  | undefined;

/** Only persisted supplier mappings can be applied without staff review. */
export function isTrustedDocumentMatch(source: DocumentMatchSource): boolean {
  return source === 'code'
    || source === 'alias_manual'
    || source === 'alias_ai'
    || source === 'alias_first_setup'
    || source === 'exact_name';
}

export function documentMatchDetailLabel(
  source: DocumentMatchSource,
  explicitlySelected = false,
): string {
  if (source === 'code') return 'Codice articolo già collegato';
  if (source === 'alias_manual') return 'Già abbinato da te';
  if (source === 'alias_ai') return 'Abbinamento storico';
  if (source === 'alias_first_setup') return 'Configurazione iniziale';
  if (source === 'exact_name') return 'Nome identico già in magazzino';
  return explicitlySelected
    ? 'Scelto da te per questa importazione'
    : 'Suggerimento basato sul nome';
}

/** A name-only suggestion must remain an explicit review gate. */
export function requireExplicitDocumentMatch(
  validation: LineValidation | null | undefined,
): LineValidation {
  const reasons = new Set(validation?.reasons ?? []);
  reasons.add('nuovo_alimento');
  return {
    status: 'da_confermare',
    reasons: Array.from(reasons),
    suggested_uom: validation?.suggested_uom ?? null,
    lot_is_placeholder: validation?.lot_is_placeholder ?? false,
  };
}
